export enum PaymentStatus {
  DONE,
  WAITING,
  CANCELLED
}